
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Control Statements`}</h1>
<p>{`Never use an `}<inlineCode parentName="p">{`if`}</inlineCode>{` statement without braces unless it's a single line `}<inlineCode parentName="p">{`if`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
if (a < b)
  return c;

// Good
if (a < b) {
  return c;
}

if (a < b) return c;
`}</code></pre>
<p>{`Never put `}<inlineCode parentName="p">{`else`}</inlineCode>{` or `}<inlineCode parentName="p">{`else if`}</inlineCode>{` in the ending brace line.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
if (a < b) {
  return c;
} else {
  return d;
}

// Good
if (a < b) {
  return c;
}
else {
  return d;
}
`}</code></pre>
<p>{`Always wrap `}<inlineCode parentName="p">{`switch`}</inlineCode>{` cases in a block.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Because `}<inlineCode parentName="p">{`let`}</inlineCode>{` and `}<inlineCode parentName="p">{`const`}</inlineCode>{` are block scoped, that means that if no block is created in the different cases, the whole switch is the nearest block and an error would be triggered because of duplicate declaration, or worse, could silently rewrite values.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
switch (type) {
  case 'primary':
    const a = 2;
    return a;
  case 'secondary': 
    const a = 1;  // triggers an error
    return a;
  default:
    return 0;
}

// Good
switch (type) {
  case 'primary': {
    const a = 2;
    return a;
  }
  case 'secondary': {
    const a = 1; 
    return a;
  }
  default: {
    return 0;
  }
}
`}</code></pre>
<p>{`Always put `}<inlineCode parentName="p">{`catch`}</inlineCode>{` in a new line.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
try {
  // ... more code ...
} catch (err) {
  // ... more code ...
}

// Good
try {
  // ... more code ...
}
catch (err) {
  // ... more code ...
}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;